var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 9.4001C10.7255 9.4001 11.8 8.32558 11.8 7.0001C11.8 5.67461 10.7255 4.6001 9.4 4.6001C8.07452 4.6001 7 5.67461 7 7.0001C7 8.32558 8.07452 9.4001 9.4 9.4001Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2001 14.1998C14.2001 15.5258 14.2001 16.5998 9.4001 16.5998C4.6001 16.5998 4.6001 15.5258 4.6001 14.1998C4.6001 12.8738 6.7481 11.7998 9.4001 11.7998C12.0521 11.7998 14.2001 12.8738 14.2001 14.1998Z",
    stroke: "#FEFEFE",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25 10.6C25 15.1252 25 17.3884 23.5936 18.7936C22.1884 20.2 19.9252 20.2 15.4 20.2H10.6C6.0748 20.2 3.8116 20.2 2.4064 18.7936C1 17.3884 1 15.1252 1 10.6C1 6.0748 1 3.8116 2.4064 2.4064C3.8116 1 6.0748 1 10.6 1H15.4C19.9252 1 22.1884 1 23.5936 2.4064C24.1576 2.9704 24.4948 3.6712 24.6976 4.6M21.4 10.6H16.6M21.4 7H15.4M21.4 14.2H17.8",
    stroke: "#FEFEFE",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalData);
export default __webpack_public_path__ + "static/media/personal-data.61eb384621e8930d0d4c9a64ee368cb1.svg";
export { ForwardRef as ReactComponent };